import { filterMode, sortMode, TextQADetail, TextQNAChannel, TextQNAQuestionDetails, TextQNAState } from './types';

export type PropType<TObj, TProp extends keyof TObj> = TObj[TProp];

const mutations = {
  initTextQnA(
    state: TextQNAState,
    {
      textQnaChannelID,
      isModerated,
      showAnswerersIdentity,
      answerersAlias
    }: {
      textQnaChannelID: string;
      isModerated: boolean;
      showAnswerersIdentity: boolean;
      answerersAlias: string;
    }
  ) {
    const textQna: PropType<TextQNAState, 'textQnA'> = {
      id: textQnaChannelID,
      isAskAnonymouslyChecked: false,
      qnaState: 'loaded',
      sortmode: state.textQnA?.sortmode || {
        label: 'Most Recent',
        value: sortMode.RECENT
      },
      olderPostsPresent: false,
      isModerated: isModerated,
      filtermode: state.textQnA?.filtermode || {
        value: filterMode.ALL,
        label: 'All'
      },
      speakerFilter: state.textQnA?.speakerFilter || {
        value: 'all',
        label: 'All'
      },
      textQNAAnswerMeta: {
        answerersAlias,
        showAnswerersIdentity
      },
      detail: {
        numberOfUserUnModdedQues: 0,
        publishedQuestion: null,
        questions: [],
        totalNoOfQuestions: 0
      }
    };
    state.textQnA = textQna;
  },
  setChannelStatus(state: TextQNAState, payload: { channelId: string; status: 'loading' | 'loaded' | 'left' }) {
    // set status of current channel ignoring all other channels
    state.channel_loading = {
      // ...state.channel_loading,
      [payload.channelId]: payload.status
    };
  },
  changeTextQnaState(state: TextQNAState, payload: PropType<TextQNAChannel, 'qnaState'>) {
    if (state.textQnA) {
      state.textQnA.qnaState = payload;
    }
  },
  toggleTextQnaModeration(state: TextQNAState, isModerated: boolean) {
    if (state.textQnA) {
      state.textQnA.isModerated = isModerated;
    }
  },
  updateOlderPostPresentFlag(state: TextQNAState, payload: boolean) {
    if (state.textQnA) {
      state.textQnA.olderPostsPresent = payload;
    }
  },
  changeTextQNASortMode(state: TextQNAState, payload: PropType<TextQNAChannel, 'sortmode'>) {
    if (state.textQnA) {
      state.textQnA.sortmode = payload;
    }
  },
  clearTextQnAs(state: TextQNAState) {
    if (state.textQnA && state.textQnA.id) {
      state.textQnA = null;
    }
  },
  updateTextQnADetails(state: TextQNAState, payload: Partial<TextQADetail>) {
    if (state.textQnA?.detail) {
      state.textQnA.detail = { ...state.textQnA.detail, ...payload };
    }
  },
  setPublishedPost(state: TextQNAState, question: TextQNAQuestionDetails) {
    if (state.textQnA?.detail) {
      state.textQnA.detail.publishedQuestion = question ? Object.assign({}, question) : null;
    }
  },
  changeTextQNAFilterMode(state: TextQNAState, payload: PropType<TextQNAChannel, 'filtermode'>) {
    if (state.textQnA) {
      state.textQnA.filtermode = payload;
    }
  },
  changeTextQNASpeakerFilter(state: TextQNAState, payload: PropType<TextQNAChannel, 'speakerFilter'>) {
    if (state.textQnA) {
      state.textQnA.speakerFilter = payload;
    }
  },
  toggleAnonymousState(state: TextQNAState) {
    if (state.textQnA) {
      state.textQnA.isAskAnonymouslyChecked = !state.textQnA.isAskAnonymouslyChecked;
    }
  },
  updateTextQnAAnswerMeta(state: TextQNAState, payload: { showAnswerersIdentity: boolean; answerersAlias: string }) {
    if (state.textQnA?.textQNAAnswerMeta) {
      state.textQnA.textQNAAnswerMeta = payload;
    }
  }
};

export type TextQnAMutations = typeof mutations;

export default mutations;
